angular.module('bmsApp.resource')
	.controller('ResourceResourceDeleteDialogCtrl', [
		'notify',
		'ResourceSvc',
		'$modalInstance',
		'resource',
		function (notify,
				  ResourceSvc,
				  $modalInstance,
				  resource) {

			var self = this;
			angular.extend(self, {
				resource: resource,
				methods: {
					cancel: cancel,
					submit: submit
				}
			});

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				self.promise = ResourceSvc.resource.delete(self.resource);
				self.promise.then(function () {
					notify({
						message: 'File deleted successfully.'
					});
					$modalInstance.close();
				}, function (errors) {
					ResourceSvc.displayErrors(errors);
				});
			}

		}
	]);
